import { PagedSearch } from '../../../shared/index';

/**
 * search fields to search for voter voice offices
 */
export class OfficeSearch extends PagedSearch {}
